
/** USER TYPES */
export const FETCH_USERS = 'FETCH_USERS';
export const SET_USERS = 'SET_USERS';
export const UPDATE_USER = 'UPDATE_USER';
export const DELETE_USER = 'DELETE_USER';
export const CREATE_INVITE_CODES = 'CREATE_INVITE_CODES';
export const CHECK_INVITE_CODE = 'CHECK_INVITE_CODE';
